import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { API_CAMBIAR_PASSWORD } from '@/config/config';

interface PasswordFormProps {
    visible: boolean;
    userId: number | null;
    onClose: () => void;
    onSuccess: () => void;
    hasExpiredPassword?: boolean;
}

const PasswordForm: React.FC<PasswordFormProps> = ({ visible, userId, onClose, onSuccess, hasExpiredPassword = false }) => {
    const endpoint = API_CAMBIAR_PASSWORD;
    const [oldPassword, setOldPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const toast = useRef<Toast>(null);

    const handlePasswordSubmit = async () => {
        if (hasExpiredPassword && !oldPassword) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Debe ingresar la contraseña antigua.' });
            return;
        }

        if (!newPassword || !confirmPassword) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Debe llenar todos los campos.' });
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Las contraseñas no coinciden.' });
            return;
        }

        try {
            const formData: any = {
                new_password: newPassword,
                old_password: newPassword,
            };

            if (hasExpiredPassword) {
                formData.old_password = oldPassword;
            }
            await axios.patch(`${endpoint}/${userId}`, {formData});
            toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Contraseña creada con éxito.' });
            onSuccess(); // Llamamos al éxito y cerramos el diálogo
        } catch (error) {
            console.error('Error al cambiar la contraseña:', error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cambiar la contraseña.' });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Establecer nueva contraseña"
                visible={visible}
                onHide={onClose}
                style={{ width: '30rem' }}
            >
                <div className="p-fluid">
                    {hasExpiredPassword && (
                        <>
                            <label htmlFor="oldPassword">Contraseña antigua</label>
                            <Password
                                id="oldPassword"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                toggleMask
                                className="w-full mb-3"
                            />
                        </>
                    )}
                    <label htmlFor="newPassword">Nueva contraseña</label>
                    <Password
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        toggleMask
                        className="w-full mb-3"
                    />

                    <label htmlFor="confirmPassword">Confirmar contraseña</label>
                    <Password
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        toggleMask
                        className="w-full mb-3"
                    />

                    <Button label="Guardar" className="w-full" onClick={handlePasswordSubmit} />
                </div>
            </Dialog>
        </>
    );
};

export default PasswordForm;
